import React from "react";
import { useDispatch } from "react-redux";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import { TextField, SubmitBtn } from "capitalrx-components";
import { formValidation } from "capitalrx-utilities";

import SectionContainer from "@/App/components/SectionContainer";
import { drugSearchActions } from "@/App/actions";
import { DrugTypes, GeneralTypes } from "@/types";

import { logEvent, ANALYTIC_EVENTS } from "@/App/utils/analytics";

type Props = InjectedFormProps;
const FORM_NAME = "TestClaimsDrugSearchForm";

const INITIAL_QUERY_OPTIONS = {
  order_by: [{ drug_name: GeneralTypes.SortOrder.Asc }],
  page_number: 1,
  results_per_page: 10,
};

const { minLength } = formValidation;
const validateMinLength = minLength(3);

const DrugSearchForm: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch();
  const { submitting, handleSubmit } = props;
  const { searchForDrug } = drugSearchActions;

  const handleSearchForDrugs = (data: DrugTypes.DrugSearchOptions): void => {
    dispatch(
      searchForDrug({
        data,
        formName: FORM_NAME,
      }),
    );
  };

  const handleFormSubmit = (data: DrugTypes.DrugSearchOptions): void => {
    // on form submit, reset the pagination/sorting to default
    handleSearchForDrugs({ ...INITIAL_QUERY_OPTIONS, ...data });

    // wants to capture drug name (a string) or NDC (all digits)
    if (data.drug_name) {
      const logMessage = /^\d+$/.test(data.drug_name.trim()) ? "searchCriteriaNDC" : "searchCriteriaDrugName";
      logEvent(ANALYTIC_EVENTS.TEST_CLAIM_DRUG[logMessage]);
    }

    logEvent(ANALYTIC_EVENTS.TEST_CLAIM_DRUG.searchForDrug);
  };

  return (
    <SectionContainer headerTitle={"Search criteria"} abilityToClose>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="row">
          <div className="col-5">
            <Field
              component={TextField}
              validate={validateMinLength}
              id="drug-name"
              data-testid="test__drug-name"
              name="drug_name"
              label="Drug Name or NDC"
              type="text"
              placeholder="Drug Name or NDC"
            />
          </div>
          <div className="col-5">
            <SubmitBtn nextToInputField fullWidth={false} submitting={submitting}>
              Search for drug
            </SubmitBtn>
          </div>
        </div>
      </form>
    </SectionContainer>
  );
};

export default reduxForm({ form: FORM_NAME })(DrugSearchForm);
